import { ParseKeys } from 'i18next'

// format message = 'message|{value: "1", value: "2"}'
export const parseI18nMessage = (message: string) => {
  if (!message.includes('|')) {
    return { key: message, values: undefined }
  }

  const [key, rawParams] = message.split('|')

  try {
    const values = JSON.parse(rawParams)
    return { key: key as ParseKeys, values }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Invalid JSON in message:', rawParams)
    return { key, values: undefined }
  }
}

export const buildI18nMessage = (
  key: ParseKeys,
  values?: Record<string, unknown>,
) => {
  if (!values || Object.keys(values).length === 0) {
    return key
  }

  const jsonParams = JSON.stringify(values)
  return `${key}|${jsonParams}`
}
